<template>
  <button
    type="button"
    class="button"
    ref="button"
    :class="cssClass"
    :disabled="disabled || loading"
  >
    <!-- icône du bouton (optionel) -->
    <template v-if="icon">
      <PhSpinner v-if="loading" class="button__icon spin" />
      <component v-else :is="icon" class="button__icon"></component>
    </template>

    <!-- libellé -->
    <span v-if="$slots.default" class="button__label" :class="labelClass"><slot /></span>
  </button>
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue'
import { PhSpinner } from '@phosphor-icons/vue'

const props = defineProps({
  // icône
  icon: {
    type: Object,
    default: () => undefined,
  },
  // styles
  bordered: {
    type: Boolean,
    default: () => false,
  },
  shadow: {
    type: Boolean,
    default: () => false,
  },
  // classes CSS
  labelClass: {
    type: String,
    default: () => '',
  },
  // couleurs
  color: {
    type: String,
    default: '',
    validator(value: string) {
      return [
        '',
        'success',
        'danger',
        'bordeaux',
        'secondary',
        'brown',
        'silver',
        'white',
        'transparent',
      ].includes(value)
    },
  },
  // tailles
  size: {
    type: String,
    default: '',
    validator(value: string) {
      return ['', 'x-small', 'small', 'large'].includes(value)
    },
  },
  // états
  disabled: {
    type: Boolean,
    default: () => false,
  },
  loading: {
    type: Boolean,
    default: () => false,
  },
})

const button = useTemplateRef('button')

const cssClass = computed(() => [
  props.bordered ? 'button--bordered' : '',
  props.shadow ? 'button--shadow' : '',
  props.disabled || props.loading ? 'button--disabled' : '',
  props.color ? `button--${props.color}` : '',
  props.size ? `button--${props.size}` : '',
])

defineExpose({ button })
</script>
